module.exports = __webpack_public_path__ + "img/ИФ-1(А)-029-m.dec5fbbe.png";